import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Tabs, Spin, Alert, Modal, Button, Tooltip } from 'antd';
import {
    getCompletedBookingHotels,
    getUpcomingBookingHotels,
    getCancelledBookingHotels,
    getHotelBookingPdf
} from '../services/auth/authServices';
import moment from 'moment';
import BookingHotelDetail from './BookingHotelDetail';
import { FaDownload, FaEye } from 'react-icons/fa';

const HotelBookingHistory = () => {
    const [activeKey, setActiveKey] = useState('1');
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [booking_id, setBooking_id] = useState(null)

    const fetchData = async (type) => {
        setLoading(true);
        setError(null);

        try {
            let data;
            if (type === '1') {
                data = await getUpcomingBookingHotels();
            } else if (type === '2') {
                data = await getCancelledBookingHotels();
            } else if (type === '3') {
                data = await getCompletedBookingHotels();
            }
            setDataSource(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(activeKey);
    }, [activeKey]);

    const onChangeTabs = (key) => {
        setActiveKey(key);
    };

    const handleAction = (record) => {
        setBooking_id(record)
        setIsModalVisible(true)
    }


    const generatePdf = async () => {
        try {
            const response = await getHotelBookingPdf(booking_id);
            setLoading(false)
            const file = new Blob([response], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = 'ticket.pdf';
            link.click();
            URL.revokeObjectURL(link.href);

        } catch (error) {
            setLoading(false)
            console.error('Error downloading the PDF:', error);
        }

    }


    const columns = [
        {
            title: 'Booking ID',
            dataIndex: 'bookingID',
            key: 'bookingID',
        },
        {
            title: 'Guest Name',
            dataIndex: 'guestName',
            key: 'guestName',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Payment Status',
            dataIndex: 'paymentStatus',
            key: 'paymentStatus',
        },
        {
            title: 'Booking Status',
            dataIndex: 'bookingStatus',
            key: 'bookingStatus',
        },
        {
            title: 'Check-in - Checkout Date',
            dataIndex: 'checkIncheckOut',
            key: 'checkIncheckOut',
        },

        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '10px' }}>
                    {/* View Button */}
                    <Tooltip title="View Details">
                        <Button
                            type="primary"
                            icon={<FaEye />}
                            onClick={() => handleAction(record?.id)}
                             aria-label="view details"
                        >

                        </Button>
                    </Tooltip>

                    {/* Download Button */}
                    <Tooltip title="Download Ticket">
                        <Button
                            type="primary"
                            icon={<FaDownload />}
                            onClick={() => generatePdf(record?.id)}
                             aria-label="download"
                        >

                        </Button>
                    </Tooltip>
                </div>
            ),
        },

    ];

    return (
        <>
            <section className='my-booking mb-5'>
                <div className='container'>
                    <Row gutter={16}>
                        <Col md={24}>
                            <Tabs
                                className='mainTabs'
                                defaultActiveKey="1"
                                onChange={onChangeTabs}
                                items={[
                                    {
                                        key: '1',
                                        label: 'Upcoming Bookings',
                                    },
                                    {
                                        key: '2',
                                        label: 'Cancelled Bookings',
                                    },
                                    {
                                        key: '3',
                                        label: 'Completed Bookings',
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row gutter={16} className="">
                        <Col md={24}>
                            {loading ? (
                                <Spin style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60vh"
                                }} />
                            ) : error ? (
                                <Alert message="Error" description={error} type="error" showIcon />
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={dataSource?.data?.map((item, index) => ({
                                        key: index,
                                        id: item?.id,
                                        bookingID: item.swt_booking_id,
                                        guestName: item.rooms[0]?.passengers?.[0]?.first_name,
                                        amount: Math.round(item.total_amount),
                                        paymentStatus: item.payment_status  === 'CHARGED' ? "SUCCESS" : item?.payment_status || 'Pending',
                                        bookingStatus: item.booking_status,
                                        checkIncheckOut: `${moment(item.from_date).format("DD MMM YYYY")} - ${moment(item.to_date).format("DD MMM YYYY")}`
                                    }))}
                                    pagination={{ pageSize: 10 }}
                                />
                            )}
                        </Col>
                    </Row>
                </div>
            </section>




            <Modal
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={false}
                width={1020}
                centered
            >
                <BookingHotelDetail booking_id={booking_id} />
            </Modal>
        </>
    );
};

export default HotelBookingHistory;
